// app/javascript/controllers/file_preview_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileInput", "filePreview", "dropzone"];
  static values = { required: Boolean };

  connect() {
    this.dropzoneTarget.addEventListener(
      "dragover",
      this.onDragOver.bind(this)
    );

    this.dropzoneTarget.addEventListener(
      "dragleave",
      this.onDragLeave.bind(this)
    );

    this.dropzoneTarget.addEventListener("drop", this.onDrop.bind(this));

    this.fileInputTarget.addEventListener("change", (e) => {
      if (e.target.files.length) {
        this.setPreview(e.target.files[0]);
        this.clearValidation();
      }
    });

    const form = this.element.closest("form");
    if (form) {
      form.addEventListener("submit", this.onFormSubmit.bind(this));
    }
  }

  openFileDialog(event) {
    event.preventDefault();
    this.fileInputTarget.click();
  }

  previewFile(event) {
    const file = event.target.files[0];
    this.setPreview(file);
  }

  onDragOver(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.add("is-dragover");
  }

  onDragLeave(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove("is-dragover");
  }

  onDrop(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove("is-dragover");

    const files = event.dataTransfer.files;
    if (!files || files.length === 0) return;

    this.setPreview(files[0]);
    this.fileInputTarget.files = files;
    this.clearValidation();
  }

  setPreview(file) {
    this.filePreviewTarget.textContent = file.name;
  }

  showValidation(message) {
    this.clearValidation();

    this.dropzoneTarget.classList.add("is-invalid");

    const validationMessage = document.createElement("div");
    validationMessage.className = "form__validation-message";
    validationMessage.textContent = message;
    validationMessage.setAttribute("role", "alert");

    this.dropzoneTarget.parentNode.insertBefore(
      validationMessage,
      this.dropzoneTarget.nextSibling
    );

    this.dropzoneTarget.focus();
  }

  clearValidation() {
    this.dropzoneTarget.classList.remove("is-invalid");

    const existingMessage = this.element.querySelector(
      ".form__validation-message"
    );
    if (existingMessage) {
      existingMessage.remove();
    }
  }

  validateFile() {
    if (this.hasRequiredValue && this.requiredValue) {
      const hasFile =
        this.fileInputTarget.files && this.fileInputTarget.files.length > 0;

      if (!hasFile) {
        this.showValidation("Bitte wählen Sie eine Datei aus.");
        return false;
      }
    }
    return true;
  }

  onFormSubmit(event) {
    if (this.hasRequiredValue && this.requiredValue) {
      if (!this.validateFile()) {
        event.preventDefault();
        return false;
      }
    }
  }
}
